module.exports = __webpack_public_path__ + "web/img/mvp-img4.d825dc77.png";